window.setCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

window.getCookie = function (cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(";");
  for (var i = 0; i < cookieArray.length; i++) {
    var cookieItem = cookieArray[i];
    while (cookieItem.charAt(0) === " ") {
      cookieItem = cookieItem.substring(1);
    }
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.substring(name.length, cookieItem.length);
    }
  }
  return "";
};

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function youtube_parser(url) {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : false;
}
function handlizer(str) {
  var handle = str
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, "");

  return handle;
}
function formatDateString(date, format = "regular", time = "") {
  var days = ["SO", "MO", "DI", "MI", "DO", "FR", "SA"];

  var newDate = date.split(" ");
  var newTime = newDate[1].split(":");

  date = newDate[0] + "T" + newDate[1] + "Z";
  var d = new Date(date);

  var month = d.getUTCMonth() + 1;
  var day = d.getUTCDate();
  var dayname = days[d.getUTCDay()] + ", ";
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();

  if (month.length < 2) {
    month = "0" + month;
  }

  var min = "",
    h = "",
    dt = "",
    mt = "",
    tm = "";

  if (day.length < 2) {
    day = "0" + day;
  }
  if (minute < 10) {
    min = 0;
  }
  if (hour < 10) {
    h = 0;
  }
  if (day < 10) {
    dt = 0;
  }
  if (month < 10) {
    mt = 0;
  }
  if (time == "false") {
    tm = "";
  } else {
    // tm = ', '+h+hour+':'+min+minute;
    tm = ", " + newTime[0] + ":" + newTime[1];
  }
  if (format == "without_day") {
    dayname = "";
  }
  return mt + month + "/" + year + tm;
  // return dayname + dt + day + "." + mt + month + "." + year + tm;
}

$(document).ready(function () {
  $(document).on(
    "mouseenter click",
    ".card-wrapper .card__color-variants .related-product .variant-swatch",
    function (e) {
      e.preventDefault();
      let $this = $(this),
        variant_image = $this.attr("data-image"),
        next_image = $this.attr("data-next-image");
      if (variant_image != "") {
        $this
          .parents(".card__content")
          .siblings(".card__inner")
          .find(".card__media")
          .find("img")
          .first()
          .attr("srcset", variant_image);
        $this
          .parents(".card__content")
          .siblings(".card__inner")
          .find(".card__media")
          .find("img")
          .first()
          .attr("src", variant_image);

        $this
          .parents(".card__content")
          .siblings(".card__inner")
          .find(".card__media")
          .find("img")
          .last()
          .attr("srcset", variant_image);
        $this
          .parents(".card__content")
          .siblings(".card__inner")
          .find(".card__media")
          .find("img")
          .last()
          .attr("src", variant_image);
      }
      /*if(next_image != ''){
      $this.parents('.card__content').siblings('.card__inner').find('.card__media').find('img').last().attr('srcset',next_image);
      $this.parents('.card__content').siblings('.card__inner').find('.card__media').find('img').last().attr('src',next_image);
    }*/
    }
  );

  $("summary.header__menu-item, .mega-menu__content").hover(function () {
    $(this).parent("details").attr("open", "open");
  });
  $("summary.header__menu-item, .mega-menu__content").mouseleave(function () {
    $(this).parent("details").removeAttr("open");
  });

  $(document).on("click", ".modalButton", function () {
    var strDataPopupName = $(this).attr("data-popup");
    if (strDataPopupName) {
      // Fade In Modal Pop Up
      $(".overlay, #" + strDataPopupName).fadeIn();
    }
  });

  // On clicking the modal background or close button
  $(document).on("click", ".overlay, .closeBtn", function () {
    $(".modal").fadeOut();
  });

  function initializeRelatedProductsSlider() {
    if ($(".related-products > .product-grid").length) {
      $(".related-products > .product-grid").slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        dots: false,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1.3,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  }

  // Use mutation observer or simple interval-based check for the class
  var checkInterval = setInterval(function () {
    if ($(".product-recommendations--loaded").length) {
      clearInterval(checkInterval); // Stop checking once the class is found

      // Initialize your slider here
      initializeRelatedProductsSlider();
    }
  }, 500); // Checks every 500ms

  if ($("#page_app").length > 0) {
    const load_wishlist_products = setInterval(function () {
      if (jQuery(".uwl-product-iteam").length > 0) {
        $(".uwl-product-iteam").each(function () {
          let price = $(this).find(".product-price del").text();
          console.log("price", price);
          if (price == "CHF 0.00") {
            $(this)
              .find(".product-price")
              .html($(this).find(".product-price > span"));
            $(this).find(".product-price del").remove();
          }
        });
        clearInterval(load_wishlist_products);
      }
    }, 1000);
  }
});

function initSlickSliders() {
  const productSliderConfig = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    dots: true,
    swipeToSlide: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  };

  const homeProdSliderSelector = "body.index .collection .product-grid";
  const pageProdSliderSelector = ".page-raw-pure .collection .product-grid";
  const balckWeekPageProdSliderSelector = ".balck-week-featured .collection .product-grid";

  if ($(homeProdSliderSelector + " .grid__item").length > 3) {
    $(homeProdSliderSelector).slick(productSliderConfig);
  }
  if ($(pageProdSliderSelector + " .grid__item").length > 3) {
    $(pageProdSliderSelector).slick(productSliderConfig);
  }
  if ($(balckWeekPageProdSliderSelector + " .grid__item").length > 3) {
    $(balckWeekPageProdSliderSelector).slick(productSliderConfig);
  }

  // For related-product slider
  var related_product_count = $(
    ".related-product-wrapper .related-product-inner .related-product"
  ).length;
  if (related_product_count > 4) {
    if (
      !$(
        ".related-product-wrapper .related-product-inner .variants-inner"
      ).hasClass("slick-initialized")
    ) {
      $(
        ".related-product-wrapper .related-product-inner .variants-inner"
      ).slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        swipeToSlide: true,
      });
    }
  } else {
    if (
      $(
        ".related-product-wrapper .related-product-inner .variants-inner"
      ).hasClass("slick-initialized")
    ) {
      $(
        ".related-product-wrapper .related-product-inner .variants-inner"
      ).slick("unslick");
    }
  }

  // For Discover more Section
  if ($(".discover-more-section .multicolumn-list").length) {
    if ($(window).width() <= 749) {
      if (
        !$(".discover-more-section .multicolumn-list").hasClass(
          "slick-initialized"
        )
      ) {
        $(".discover-more-section .multicolumn-list").slick({
          dots: true,
          arrows: true,
          prevArrow:
            '<button type="button" class="slick-prev"><svg class="icon" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m22 6l8 10l-8 10m8-10H2"></path></svg><i class="icon-arrow"></i></button>',
          nextArrow:
            '<button type="button" class="slick-next"><svg class="icon" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m22 6l8 10l-8 10m8-10H2"></path></svg><i class="icon-arrow"></i></button>',
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          centerMode: true,
          infinite: true,
          swipeToSlide: true,
          centerPadding: "120px",
          responsive: [
            {
              breakpoint: 380,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerPadding: "60px",
                dots: true,
              },
            },
          ],
        });
      }
    } else {
      if (
        $(".discover-more-section .multicolumn-list").hasClass(
          "slick-initialized"
        )
      ) {
        $(".discover-more-section .multicolumn-list").slick("unslick");
      }
    }
  }

  $(
    ".materialien-technologien-multipleImage-with-text-sec .image-with-text__grid .image-with-text__media"
  ).slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: false,
    arrows: true,
  });

  $(".section-brand-details .brand-info-slider").slick(productSliderConfig);
}

$(document).ready(function () {
  initSlickSliders();

  $(window).resize(function () {
    initSlickSliders(); // Reinitialize sliders on window resize
  });
});

$(document).ready(function () {
  jQuery(".menu-drawer__inner-container ul.first-level-menu-tabs")
    .find(".main-nav")
    .on("click", function () {
      const $parentCol = jQuery(this).closest(".menu-item");
      const isActive = $parentCol.hasClass("active");

      jQuery(".menu-item").removeClass("active");

      if (!isActive) {
        $parentCol.addClass("active");
      }

      jQuery(this).next(".tabs-content-wrap").slideToggle(300);
      jQuery(".tabs-content-wrap").not(jQuery(this).next()).slideUp(300);
      $(".slider-for.has_slider").slick("setPosition");
      $(".slider-nav").slick("setPosition");
    });

  $(() => {
    // Card's slider
    const $carousel = $(
      ".menu-drawer__inner-container .second-level-menu .slider-container .slider-for.has_slider"
    );

    $carousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      // arrows: true,
      fade: false,
      adaptiveHeight: true,
      asNavFor: ".slider-nav",
      infinite: false,
      prevArrow:
        '<div class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left"><path d="m15 18-6-6 6-6"/></svg></div>',
      nextArrow:
        '<div class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg></div>',
    });

    $(
      ".menu-drawer__inner-container .second-level-menu .slider-container .slider-nav"
    ).slick({
      variableWidth: true,
      slidesToScroll: 1,
      asNavFor:
        ".menu-drawer__inner-container .second-level-menu .slider-container .slider-for.has_slider",
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      variableWidth: true,
      infinite: false,
    });
  });
});

$(function () {
  $(".link-active").parents(".menu-item").addClass("parent-link-active");
  $(".mega-menu__link--active")
    .parents(".mega-menu__content")
    .prev()
    .children("span")
    .addClass("header__active-menu-item");

  // let TransationObjEn = {
  //   women: "Women",
  //   men: "Men",
  //   kids: "Junior & Kids",
  // };

  // let TransationObjFr = {
  //   women: "Femmes",
  //   men: "Hommes",
  //   kids: "Junior et Enfants",
  // };

  // let TransationObjIt = {
  //   women: "Donne",
  //   men: "Uomini",
  //   kids: "Junior e Bambini",
  // };

  // let TransationObjDe = {
  //   women: "Frauen",
  //   men: "Männer",
  //   kids: "Junior & Kinder",
  // };
  // let TransationObj = TransationObjEn;
  // if (Shopify.locale == "de") {
  //   TransationObj = TransationObjDe;
  // }
  // if (Shopify.locale == "fr") {
  //   TransationObj = TransationObjFr;
  // }
  // if (Shopify.locale == "it") {
  //   TransationObj = TransationObjIt;
  // }

  // aico
  // $("#ProductGridContainer").before(`<div class="aico-btn-container page-width">
  //       <button class="audience-btn" collection-handle="women" search-value="audience_Women">${TransationObj.women}</button>
  //       <button class="audience-btn" collection-handle="men" search-value="audience_Men">${TransationObj.men}</button>
  //       <button class="audience-btn" collection-handle="junior-kids-1" search-value="audience_Junior & Kids">${TransationObj.kids}</button>
  //   </div>`);

  // if (aico.collecton_handle == "men") {
  //   $("[collection-handle='men']").addClass("af-selected");
  // } else if (aico.collecton_handle == "women") {
  //   $("[collection-handle='women']").addClass("af-selected");
  // } else if (aico.collecton_handle == "junior-kids-1") {
  //   $("[collection-handle='junior-kids-1']").addClass("af-selected");
  // }

  // $(".audience-btn").hover(
  //   function () {
  //     $(this).addClass("active");
  //   },
  //   function () {
  //     $(this).removeClass("active");
  //   }
  // );
});

// collectionSearch();
// function collectionSearch() {
//   aico.jq(document).on("click", ".audience-btn", function (event) {
//     event.preventDefault();
//     let inputType = "single";
//     let searchValue = $(this).attr("search-value");
//     $(".audience-btn").removeClass("af-selected");
//     $(this).addClass("af-selected");
//     request_data["aico_t_shop_by_audience"] = [searchValue];

//     delete request_data.page;
//     aico.jq.ajax({
//       url: aico.aico_url + "api/filter-data",
//       method: "POST",
//       data: request_data,
//       success: function (response) {
//         removeParamsFromUrl();
//         appendAicoParamsToUrl();
//         aico.jq(".aico-vendors").remove();
//         multipleAndSingleListHtml(response.filter);
//         aico.jq(".aico-collection-append").html("");
//         collectionHtml(response);
//         aico.jq(".aico-metafield-append").html("");
//         metfieldHtml(response);
//         productOptionsFilters(response);
//         nouiSliderPrice(response);
//         rangeSliderHtml(response);
//         if (inputType != "multiple") {
//           aico.jq(".aico-tags").remove();
//           tagsList(response);
//         }
//         productsAppendAfterRespons(response);
//         selectedList(request_data, response);
//         aico.jq(".aico-pagination").remove();
//         makePagination(response.product_count);
//         if (inputType === "multiple") {
//           checkedValues.map((input_value) => {
//             var checkboxes = aico.jq(
//               'input[type="checkbox"][value="' + input_value + '"]'
//             );
//             let checkedProp = checkboxes.prop("checked", true);
//           });
//         }
//         onloadCheckValue(request_data, inputType);
//         aico.jq(".af-filter-message").remove();
//         selectedTagChecked(request_data);
//         if (response.total_product == 0) {
//           emptyFunctionLoad();
//         }
//         collectionProductDiscount(response);
//         removeRefineByIflengthIsZero();
//         activeSpacificClear(request_data, "aico_t_shop_by_audience");
//         commonFunctionLoad(response);
//       },
//     });
//   });
// }

$(".raw_pure_slider").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  swipeToSlide: true,
});

$(document).ready(function () {
  let hulk_uuid = getCookie("hulk_wishlist_UserUUID");
  if (hulk_uuid) {
    const setWishlistCount = (count) => {
      $(`.header__icon--wishlist .header-count[data-totalwishlistitems]`)
        .text(count)
        .toggleClass("hidden", count === 0);
    };
    const hulk_api = `${window.Shopify.routes.root}apps/advanced-wishlist/api/wishlist/count/guest?uuid=${hulk_uuid}&shop=${Shopify.shop}`;
    fetch(hulk_api)
      .then((res) => res.json())
      .then((data) => setWishlistCount(data.wishlist_count));
  } else {
    $(
      `.header__icon--wishlist .header-count[data-totalwishlistitems]`
    ).addClass("hidden");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const colorVariants = document.querySelectorAll(".aico-color-variant");

  colorVariants.forEach((variant) => {
    const imgURL = variant.getAttribute("aico_var_img");
    if (imgURL) {
      const img = new Image();
      img.src = imgURL;
      img.onload = () => console.log(`Preloaded: ${imgURL}`);
      img.onerror = () => console.error(`Failed to preload: ${imgURL}`);
    }
  });
});

document.body.addEventListener("click", function (event) {
  const target = event.target.closest(".aico-pagination-item");
  if (target) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
});


// bottom to top scroll button js start
// (function ($) {
//   "use strict";

//   $(document).ready(function () {
//     "use strict";

//     //Scroll back to top

//     var progressPath = document.querySelector(
//       ".bottom_to_top_progress_wrap path"
//     );
//     var pathLength = progressPath.getTotalLength();
//     progressPath.style.transition = progressPath.style.WebkitTransition =
//       "none";
//     progressPath.style.strokeDasharray = pathLength + " " + pathLength;
//     progressPath.style.strokeDashoffset = pathLength;
//     progressPath.getBoundingClientRect();
//     progressPath.style.transition = progressPath.style.WebkitTransition =
//       "stroke-dashoffset 10ms linear";
//     var updateProgress = function () {
//       var scroll = $(window).scrollTop();
//       var height = $(document).height() - $(window).height();
//       var docheight = $(".footer").height();
//       var progress = pathLength - (scroll * pathLength) / height;
//       progressPath.style.strokeDashoffset = progress;
//       if ($(".social").length > 0) {
//         var footerOffset = $(".social").offset().top;
//         if (scroll >= footerOffset) {
//           $(".bottom_to_top_progress_wrap").addClass("reached-footer");
//         } else {
//           $(".bottom_to_top_progress_wrap").removeClass("reached-footer");
//         }
//       }
//     };
//     updateProgress();
//     $(window).scroll(updateProgress); 
//     var offset = 50;
//     var duration = 550;
//     jQuery(window).on("scroll", function () {
//       if (jQuery(this).scrollTop() > offset) {
//         jQuery(".bottom_to_top_progress_wrap").addClass("active-progress");
//         jQuery("#freshworks-container").addClass("active-progress");
//         $(".aico-review-widget").addClass(
//           "active-progress"
//         );
//       } else {
//         jQuery(".bottom_to_top_progress_wrap").removeClass("active-progress");
//         jQuery("#freshworks-container").removeClass("active-progress");
//         $(".aico-review-widget").removeClass(
//           "active-progress"
//         );
//       }
//     });

  

//     jQuery(".bottom_to_top_progress_wrap").on("click", function (event) {
//       event.preventDefault();

//       jQuery("html, body").animate({ scrollTop: 0 }, 550);

//       return false;
//     });
//   });
// })(jQuery);
// bottom to top scroll button js start


// bottom to top scroll button js start
(function ($) {
  "use strict";

  $(document).ready(function () {
    "use strict";

    //Scroll back to top

   
    var offset = 50;
    var duration = 550;
    jQuery(window).on("scroll", function () {
      if (jQuery(this).scrollTop() > offset) {
       
        $(".aico-review-widget").addClass(
          "active-progress"
        );
      } else {
      
        $(".aico-review-widget").removeClass(
          "active-progress"
        );
      }
    });


   
  });
})(jQuery);
// bottom to top scroll button js start
